import * as React from "react";
import { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useSelector } from "react-redux";
import { debounce } from "lodash";
import { Typography } from "@mui/material";
import { useCallback, useMemo } from "react";

import { useCard } from "../../../../reactQuery/cards";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import FormDialog from "../../../../components/Dialog/FormDialog";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";
import { useMoveWorklogMutation } from "./hooks/useMoveWorklogMutation";

export default React.memo(function MoveWorklog({ cardId, disabled = false }) {
  const [cardIdInput, setCardIdInput] = useState("");
  const [targetCard, setTargetCard] = useState(null);
  const [newCardId, setNewCardId] = useState(null);
  const [confirmationMoveWorklog, setConfirmationMoveWorklog] = useState(false);
  const { id } = useBoardIdByKey();
  const [brd_id] = useCustomSearchParams("brd_id");
  const [crd_id] = useCustomSearchParams("card_id");
  const selectedIds = useSelector((state) => state.checkbox.checkedIds);
  const { card, isLoading } = useCard(cardIdInput);

  // Check if any worklogs are selected
  const isWorklogSelected = useMemo(() => selectedIds.length > 0, [selectedIds]);

  useEffect(() => {
    if (card && card?.data) {
      setTargetCard([card?.data?.data?.responseData]);
    } else {
      setTargetCard(null);
    }
  }, [card]);

  const handleConfirmationMoveWorklog = () => {
    setConfirmationMoveWorklog(false);
  };

  const { moveSelectedWorklogs } = useMoveWorklogMutation({
    cardId,
    boardId: id ?? Number(brd_id),
    currentCardId: cardId ?? Number(crd_id),
    selectedIds,
    onComplete: () => {
      setTargetCard(null);
      handleConfirmationMoveWorklog();
    },
  });

  const callback = useCallback(() => {
    moveSelectedWorklogs(newCardId);
  }, [moveSelectedWorklogs, newCardId]);

  const optionValues = useMemo(() => {
    return targetCard ? targetCard : [];
  }, [targetCard]);

  const handleInputId = (Id) => {
    setCardIdInput(Id);
  };
  const debounceSearch = debounce(handleInputId, 1000);

  return (
    <>
      {confirmationMoveWorklog && (
        <FormDialog
          open={confirmationMoveWorklog}
          handleClose={handleConfirmationMoveWorklog}
          loading={isLoading}
          handleSubmit={callback}
          buttonTxt="Submit"
          title="Confirmation: Move Confirmation"
          alignActions="center"
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure you want to Move Worklogs?
          </Typography>
        </FormDialog>
      )}
      <FormControl className="checkbox-outerbox" size="small" fullWidth>
        <Autocomplete
          options={optionValues}
          getOptionLabel={(option) => option.title}
          onInputChange={(event, newValue) => {
            debounceSearch(newValue);
          }}
          filterOptions={(optionValues, state) => {
            return optionValues.filter(
              (option) =>
                option?.card_id?.toString()?.includes(state.inputValue) // Search by id
            );
          }}
          onChange={(event, newValue) => {
            setNewCardId(newValue?.card_id);
            setConfirmationMoveWorklog(true);
          }}
          disabled={disabled || !isWorklogSelected}
          loading={isLoading}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Enter task ID"
              size="small"
              helperText={isLoading ? "Loading..." : !isWorklogSelected ? "Please select at least one worklog" : ""}
            />
          )}
        />
      </FormControl>
    </>
  );
})
